import { createFileRoute } from "@tanstack/react-router";
import { ProfileContactSection, ProfileHeader } from "@/components/profile/profile-form";
import NotificationPreferences from "@/components/profile/notification-preferences";
import UiModalPreferencesPanel from "@/components/profile/ui-modal-preferences";
import SessionsManager from "@/components/profile/sessions-manager";

export const Route = createFileRoute("/_authenticated/profile")({
  component: ProfilePage,
});

/**
 * Perfil con el formato de Configuración → Colecciones: una cabecera
 * (foto, nombre y acciones) y secciones colapsables con filas compactas.
 * Todo se guarda al cambiarlo, sin botones de guardar.
 */
function ProfilePage() {
  return (
    <div className="flex min-h-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-2 pb-6">
        <ProfileHeader />
        <ProfileContactSection />
        <NotificationPreferences />
        <UiModalPreferencesPanel />
        <SessionsManager />
      </div>
    </div>
  );
}
